import logobot from './img/logo.svg';
export const faqData = {
  "Řešení na míru": "TAOX se nesoustředí na hotová řešení, ale na tvorbu webových stránek a aplikací na míru dle specifických požadavků klienta.",
  "Široké spektrum služeb": "TAOX nabízí komplexní služby v oblasti internetového marketingu, od tvorby webových stránek a e-shopů, přes grafický design a video produkci, až po marketingové kampaně a SEO optimalizaci.",
  "Dlouholeté zkušenosti": "Studio TAOX působí na trhu již od roku 1999 a za tu dobu nasbíralo bohaté zkušenosti s tvorbou webových stránek a aplikací pro různé typy klientů.",
  "Benefity TAOX": "Za web od nás, neplatíte žádný paušál. Instalujeme Vám moderní řešení, kterí běží samostatně mnoho let. Dokážeme vyhovět jakýmkoliv požadavkům. Grafiku navrhneme podle Vašich představ. Jsme flexibilní a cenově dostupní profesionálové.",
   
};
export const FAQ = ({ onQuestionClick }) => {
  return (
    <div>
      <div className="hlavni-font-div"><h1 className="hlavni-font">Taox bot</h1><img src={logobot} alt="logo-bot" style={{ width: '10%', height: 'auto', marginLeft:'1%' }}/></div>
      <div className="qwerty">
      {Object.keys(faqData).map((question, index) => (
        <div className="btn-dotazy" key={index} onClick={() => onQuestionClick(question)}>
          <h3 className="sdfgh">{question}</h3>
        </div>
      ))}
      </div>
    </div>
  );
};
